import { render } from "./LivraisonsCommande.vue?vue&type=template&id=7b8490ee"
import script from "./LivraisonsCommande.vue?vue&type=script&lang=ts"
export * from "./LivraisonsCommande.vue?vue&type=script&lang=ts"
script.render = render

export default script